import React, { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { RoleProvider } from './context/RoleContext';
import { ChatProvider } from './context/ChatContext';
import { FactCheckProvider } from './context/FactCheckContext';
import AppShell from './components/AppShell';
import SplashScreen from './components/SplashScreen';

function App() {
  const [showSplash, setShowSplash] = useState(true);
  const [appReady, setAppReady] = useState(false);

  // Check if this is a fresh page load (not a navigation)
  useEffect(() => {
    // Check sessionStorage to avoid showing splash on every route change
    const hasSeenSplash = sessionStorage.getItem('hasSeenSplash');
    if (hasSeenSplash) {
      setShowSplash(false);
      setAppReady(true);
    }
  }, []);

  const handleSplashComplete = () => {
    sessionStorage.setItem('hasSeenSplash', 'true');
    setShowSplash(false);
    setAppReady(true);
  };

  return (
    <RoleProvider>
      <ChatProvider>
        <FactCheckProvider>
          {showSplash && <SplashScreen onComplete={handleSplashComplete} />}
          {appReady && (
            <BrowserRouter>
              <Routes>
                <Route
                  path="/*"
                  element={<AppShell />}
                />
              </Routes>
            </BrowserRouter>
          )}
        </FactCheckProvider>
      </ChatProvider>
    </RoleProvider>
  );
}

export default App;
